
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","stroke":"#6C7684","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 5.5h3M3 5.5h11M10 12.5h11M3 12.5h3M18 19.5h3M3 19.5h11M17.414 4.086a2 2 0 11-2.828 2.828 2 2 0 012.828-2.828M9.414 11.086a2 2 0 11-2.828 2.828 2 2 0 012.828-2.828M17.414 18.086a2 2 0 11-2.828 2.828 2 2 0 012.828-2.828","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    